import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const TAB_CONTENT_PADDING_X = 16;

export const StyledLeadsPageIconWrapper = styled.div`
    padding: 7px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledLeadsPageTitle = styled.h1`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])};

    margin: 0;
`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const StyledLeadsPageTitleWrapper = styled(Flex).attrs({ "data-automation": "page-title" })`
    height: 48px;
    align-items: center;
    justify-content: space-between;
    column-gap: 8px;
    padding: 4px 8px 4px 4px;

    border-radius: 8px;
    background-color: ${colorsPalettes.carbon[25]};
`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const StyledLeadsPageActionsWrapper = styled(Flex).attrs({ "data-automation": "page-actions" })`
    column-gap: 8px;
    align-items: center;
`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const StyledLeadsPageHeaderWrapper = styled(Flex).attrs({ "data-automation": "page-header" })`
    align-items: center;
    justify-content: space-between;
    padding: 16px 16px 8px 32px;

    background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledLeadsBaseContentContainer = styled.div`
    min-width: 0;
    background-color: ${colorsPalettes.carbon["0"]};
    box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    border-radius: 8px;
`;

export const StyledLeadsMainContent = styled(StyledLeadsBaseContentContainer)`
    display: flex;
    flex-direction: column;
    flex: 1 1;
`;

export const StyledLeadsTableWrapper = styled(StyledLeadsMainContent)`
    overflow: hidden;

    & > *:not(:last-child) {
        border-bottom: 1px inset ${colorsPalettes.carbon[50]};
    }
`;

export const StyledLeadsTabContent = styled(FlexRow)`
    gap: 8px;
    height: calc(100% - ${TAB_CONTENT_PADDING_X * 2}px);
    padding: ${TAB_CONTENT_PADDING_X}px 32px;
`;

export const StyledLeadsPageRoot = styled(Stack)`
    height: 100%;
`;
